import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Cookie, Bone, Cake, ArrowRight, PartyPopper } from 'lucide-react';
import Reveal from '../ui/Reveal';

function FloatIcon({ Icon, className, delay = 0, duration = 6 }) {
  return (
    <motion.div
      aria-hidden
      animate={{ y: [0, -14, 0], rotate: [0, 8, 0] }}
      transition={{ duration, delay, repeat: Infinity, ease: 'easeInOut' }}
      className={`absolute ${className}`}
    >
      <div className="bg-white rounded-2xl shadow-lg p-3">
        <Icon className="w-6 h-6 text-amber-500" />
      </div>
    </motion.div>
  );
}

// The thing no other groomer has: an actual bakery counter.
export default function Bakery() {
  return (
    <section className="relative py-20 md:py-28 bg-gradient-to-br from-amber-50 via-pink-50 to-rose-50 overflow-hidden">
      <p aria-hidden className="pointer-events-none select-none absolute -bottom-6 left-1/2 -translate-x-1/2 whitespace-nowrap font-display font-black text-[20vw] leading-none text-amber-500/[0.07]">
        treats
      </p>
      <FloatIcon Icon={Cookie} className="top-12 left-[8%]" />
      <FloatIcon Icon={Bone} className="top-24 right-[10%]" delay={1} duration={7} />
      <FloatIcon Icon={Cake} className="bottom-16 left-[16%]" delay={0.5} duration={8} />

      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <Reveal>
          <p className="text-xs md:text-sm font-extrabold uppercase tracking-[0.22em] text-amber-600">Spa &amp; Bakery</p>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl font-black text-ink-900 leading-[1.05] tracking-tight">
            Every spa day ends at
            <span className="italic bg-gradient-to-r from-amber-500 via-pink-500 to-rose-500 bg-clip-text text-transparent"> the treat counter.</span>
          </h2>
          <p className="mt-5 text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Pet-safe goodies — pup cakes, cookies and birthday surprises.
            Because a superstar deserves a standing ovation <em>and</em> a snack.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-9 inline-flex flex-col sm:flex-row items-center gap-4">
            <Link
              to="/booking"
              className="inline-flex items-center space-x-2.5 bg-ink-900 hover:bg-ink-800 text-white px-8 py-4 rounded-full font-extrabold shadow-xl transition-all duration-300 hover:scale-[1.03]"
            >
              <PartyPopper className="w-5 h-5 text-amber-400" />
              <span>Ask about Birthday Packages</span>
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
